import {ASeDefinitionFiltre, ASeDefinitionTri} from "./ASeExecuterRecherche";

//Représente les paramètres d’exportation d’une grille vers Excel
export class ASeExporterGrilleVersExcelParametres 
{
  //Création
  constructor ()
  {
    this.definitionsTris = [];
    this.definitionsFiltres = [];
  }

  //Domaine
  public domaine!: string;

  //Identifiant de l’onglet
  public identifiantOnglet!: string;

  //Définitions des tris
  public definitionsTris: ASeDefinitionTri[];

  //Définitions des filtres
  public definitionsFiltres: ASeDefinitionFiltre[];
}
